import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: 'app-input-checkbox',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputCheckboxComponent,
            multi: true
        }
    ],
    templateUrl: './input-checkbox.component.html',
    styleUrls: ['./input-checkbox.component.scss']
})
export class InputCheckboxComponent implements OnInit, ControlValueAccessor {
    // Right label is given as ng-content
    @Input() label = '';
    @HostBinding('class.selected') @Input() selected = false;

    @Output() select = new EventEmitter<any>();

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};
    @HostBinding('class.no-label') get noLabel(): boolean {
        return !this.label;
    }

    @HostListener('click', ['$event.target'])
    onToggle() {
        this.selected = !this.selected;
        this.select.emit(this.selected);

        if (this.onTouchedCallback) {
            this.onTouchedCallback(this.selected)
        }

        if (this.onChangeCallback) {
            this.onChangeCallback(this.selected);
        }
    }

    constructor() {
    }

    ngOnInit() {
    }

    get value() {
        return this.selected || false;
    }

    writeValue(isSelected) {
        this.selected = isSelected;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

}
